// types
import { PlanItem } from 'components/pricing';

import { Feature } from './types';

const features: Feature[] = [
  {
    avatar: "users",
    title: "All in One Dashboard",
    description:
      "Streamline your hoarding board management with centralized control. Simplify organization by managing all boards in one place.",
    variant: "primary",
    containerClass: "d-flex border-bottom pb-4",
  },
  {
    avatar: "user-plus",
    title: "Manage multiple people",
    description:
      "With this software, you can efficiently oversee and coordinate multiple individuals with ease.",
    variant: "success",
    containerClass: "d-flex border-bottom py-4",
  },
  {
    avatar: "bar-chart",
    title: "Scalability",
    description:
      "SnapAds grows with your business, offering scalable solutions for expanding advertising needs.",
    variant: "orange",
    containerClass: "d-flex pt-4",
  },
];
const free: PlanItem[] = [
  {
    id: 1,
    name: "Free plan",
    price: "0",
    duration: "Free Forever",
    features: [
      "Upto 10 Hoarding Boards",

      "Free onboarding & assistence",
      "Single admin User",
      "Upto 3 staff user",
      "Upto 5 image upload per hoarding board",
      "Unlimited Expiry alerts",
      "upto 200 generated private links / month",
      "Technical support via email",
    ],
    isRecommended: false,
    button:"Get Started"
  },
];

const combo: PlanItem[] = [
  {
    id: 1,
    name: "Pro plan",
    price: "5499",
    duration: "Price/month",
    features: [
      "Upto 30 Hoarding Boards",
      "Free assistence over call & Virtual Meet",
      "upto 3 admin User",
      "Unlimited staff user",
      "Upto 5 image upload per hoarding board",
      "Unlimited Expiry alerts",
      "upto 2000 generated private links / month",
      "Technical support via email & Whatsapp",
    ],
    isRecommended: true,
    isPopular: true,
    button: "Get Started",
  },
  {
    id: 2,
    name: "Business Plan",
    price: "8999",
    duration: "Price/month",
    features: [
      "Upto 50 Hoarding Boards",
      "Free assistence over call & Virtual Meet",
      "upto 5 admin User",
      "Unlimited staff user",
      "Upto 5 image upload per hoarding board",
      "Unlimited Expiry alerts",
      "Unlimted generated private links / month",
      "Custom Domain Mapping",
      "Technical support via email & Whatsapp",
    ],
    isRecommended: true,
    isPopular: true,
    button: "Get Started",
  },
  {
    id: 3,
    name: "Enterprises plan",
    price: "Custom Pricing",
    duration: "Per Month",
    features: [
      "Full Product Benefits",
      "Unlimted Software Updates",
      "White labeling",
      "Custom Domain Mapping",
    ],
    isRecommended: true,
    isPopular: true,
    button: "Get Quotes",
  },
];
const payus: PlanItem[] = [
  {
    id: 1,
    name: "Pay Us You Go",
    price: "250",
    duration: "Per Hoarding Board/Month",
    features: [
      "First 10 Hoarding Boards at Free of Cost",
      "Full Product Benefits",
      "Unlimted Software Updates",
      "White labeling",
      "Custom Domain Mapping",
    ],
    isRecommended: true,
    isPopular: true,
    button: "Get Started",
  },
];
const plans: PlanItem[] = [
  {
    id: 1,
    name: "Quaterly plan",
    price: "",
    duration: "Pay for a month , use for 3 month",
    features: [
      "Free assistence",
      "Single admin User",
      "Multiple staff login",
      "24/7 customer service",
      "Technical support via email",
    ],
    isRecommended: false,
    button: "Get Started",
  },
  {
    id: 2,
    name: "Halfly plan",
    price: "",
    duration: "Pay for 3 month , use for 6 month",
    features: [
      "Free assistence",
      "Single admin User",
      "Multiple staff login",
      "24/7 customer service",
      "Technical support via email",
    ],
    isRecommended: true,
    button: "Get Started",
  },
  {
    id: 3,
    name: "Yearly plan",
    price: "",
    duration: "Pay for 6 month , use for 12 month",
    features: [
      "Free assistence",
      "Single admin User",
      "Multiple staff login",
      "24/7 customer service",
      "Technical support via email",
    ],
    isRecommended: false,
    button: "Get Started",
  },
];

export { payus,free,combo,features, plans };
